import { render, staticRenderFns } from "./addLogo.vue?vue&type=template&id=3f7fbe36&"
import script from "./addLogo.vue?vue&type=script&lang=js&"
export * from "./addLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f7fbe36')) {
      api.createRecord('3f7fbe36', component.options)
    } else {
      api.reload('3f7fbe36', component.options)
    }
    module.hot.accept("./addLogo.vue?vue&type=template&id=3f7fbe36&", function () {
      api.rerender('3f7fbe36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/addLogo.vue"
export default component.exports